import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import cn from "classnames";
const ToggleButton = ({ placeholder, onChange, id, defaultCheck, className }) => {
    const [checked, setChecked] = useState(defaultCheck !== undefined ? defaultCheck : false);
    const handleChange = () => {
        setChecked(!checked);
        onChange(!checked);
    };
    return (_jsxs("div", { className: cn("toggle-btn-group", className), children: [_jsx("div", { className: "toggle-btn-group__text", children: placeholder }), _jsx("label", { htmlFor: id, className: "flex items-center", children: _jsxs("div", { className: "toggle-btn-group__control", children: [_jsx("input", { type: "checkbox", id: id, className: "sr-only", onChange: handleChange }), _jsx("div", { className: "toggle-btn-group__control-btn" }), _jsx("div", { className: "toggle-btn-group__control-dot" })] }) })] }));
};
export default ToggleButton;
